import { getWindow } from "@faire/globals/browser/getWindow";
import debounce from "lodash/debounce";

export const debounceIfPossible = <T extends (...args: never[]) => unknown>(
  func: T,
  wait?: number,
  options?: Parameters<typeof debounce>[2]
): ReturnType<typeof debounce> | T => {
  // We don't allow debouncing in SSR environments.
  return getWindow() == null ? func : debounce(func, wait, options);
};
